<ng-container
  *ngrxLet="{
    companyUser: currentCompanyUser$,
    allCompanyUsers: allCompanyUsers$,
    activeCompanyUsers: activeCompanyUsers$,
    inactiveCompanyUsers: inactiveCompanyUsers$,
  } as vm">
  <terra-select
    class="company-menu__select"
    [class]="{ 'company-menu__select--dark': theme === Theme.DUAL }"
    [ngModel]="vm.companyUser"
    (selectionChange)="switchCompany($event)"
    [compareWith]="compareByCompanyId"
    (openedChange)="selectOpenChanged($event)"
    maxHeight="60%"
    maxWidth="320px"
    [disabled]="!vm.allCompanyUsers?.length"
    data-cy="company-menu_company-button">
    <terra-select-trigger
      class="company-menu__trigger"
      [class]="{ 'company-menu__trigger--collapsed': isSidenavExpanded === false }">
      <ninety-company-logo
        attr.data-cy="company-menu_company-name-{{ vm.companyUser?.companyName }}"
        [userLogoSrc]="vm.companyUser?.logoUrl"
        [companyName]="vm.companyUser?.companyName"
        [isSideNavExpanded]="isSidenavExpanded"
        [inSidenav]="true"
        [showDropDownIcon]="isSidenavExpanded && vm.allCompanyUsers?.length > 0"
        [dropDownIconDirection]="isSelectOpen() ? 'up' : 'down'"
        [theme]="theme">
      </ninety-company-logo>
    </terra-select-trigger>
    @if (vm.allCompanyUsers?.length > 5) {
      <terra-select-search>
        <terra-search-input
          [(ngModel)]="companySearch"
          placeholder="Search companies"
          aria-label="company search"
          data-cy="company-menu_company-search-input" />
      </terra-select-search>
    }
    @for (company of vm.activeCompanyUsers | searchCompanyFilter: companySearch; track company.companyId) {
      @let unreachable = company.reachable === false;
      <terra-option
        [value]="company"
        [disabled]="unreachable"
        [matTooltip]="unreachable ? unreachableTooltip : ''"
        attr.data-cy="company-menu_company-select-option-{{ company.companyName }}">
        <terra-option-image *terraOptionPrefix [src]="company?.logoUrl ? company.logoUrl : ''" />
        {{ company.companyName }}
        <ng-container *terraOptionSuffix>
          @if (company.accessSuspended) {
            <span data-cy="company-menu_suspended-badge">SUSPENDED</span>
          }
        </ng-container>
      </terra-option>
    }
    <terra-divider />

    @for (
      inactiveCompany of vm.inactiveCompanyUsers | searchCompanyFilter: companySearch;
      track inactiveCompany.companyId
    ) {
      <terra-option
        [value]="inactiveCompany"
        attr.data-cy="company-menu_company-select-option-{{ inactiveCompany.companyName }}">
        <terra-option-image *terraOptionPrefix [src]="inactiveCompany?.logoUrl ? inactiveCompany.logoUrl : ''" />
        {{ inactiveCompany.companyName }}
        <span *terraOptionSuffix>INACTIVE</span>
      </terra-option>
    }
  </terra-select>
</ng-container>
